// test2290
(2290 && 0);
